var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-4h24v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l-4 4h3c0 3.31-2.69 6-6 6a5.87 5.87 0 01-2.8-.7l-1.46 1.46A7.93 7.93 0 0011 16c4.42 0 8-3.58 8-8h3l-4-4zM5 8c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0011 0C6.58 0 3 3.58 3 8H0l4 4 4-4H5z",
    fill: "#0073B1"
  }))));
}
export default __webpack_public_path__ + "img/c205eb1c011103d71dd429a3d2164739.svg";
export { SvgReset as ReactComponent };